// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import GLOBALS, { BOOLEAN_STRINGS, type BooleanStringType } from 'client/constants/globals';
import { COOKIE_BANNER_DISMISSED } from 'client/constants/amplitudeTracker';
import { Tracking } from 'web-core/src/tracking';
import CookieUtils from 'web-core/src/utils/cookie';
import Translate from 'client/components/translate';
import 'client/styles/cookieBanner.scss';

const USER_PRIVACY_COOKIE_NAME = 'wasPrivacyBannerViewed';

type GetCookieType = BooleanStringType | string;

type State = {
  wasPrivacyBannerViewed: GetCookieType,
};

type Props = {
  isPartnerSite: Boolean,
};

const mapStateToProps = state => ({
  isPartnerSite:
    _.get(state, 'siteConfigs.partnerAgencyInfo.partnerInfo.partnershipType', '') === 'ENTERPRISE' ||
    _.get(state, 'siteConfigs.partnerAgencyInfo.partnerInfo.partnershipType', '') === 'WHITE_LABEL',
});

class CookieBanner extends Component<Props, State> {
  state = {
    [USER_PRIVACY_COOKIE_NAME]: BOOLEAN_STRINGS.FALSE,
  };

  componentDidMount() {
    this.onMount();
  }

  onMount = () => {
    const wasPrivacyBannerViewed = CookieUtils.getCookie(USER_PRIVACY_COOKIE_NAME);
    if (wasPrivacyBannerViewed === BOOLEAN_STRINGS.TRUE) {
      this.setState({ wasPrivacyBannerViewed });
    } else {
      CookieUtils.setCookie(
        `${USER_PRIVACY_COOKIE_NAME}=${BOOLEAN_STRINGS.FALSE}`,
        GLOBALS.ONE_YEAR_IN_MILLISECONDS,
      );
    }
  };

  handleClick = () => {
    this.setState(
      {
        [USER_PRIVACY_COOKIE_NAME]: BOOLEAN_STRINGS.TRUE,
      },
      () => {
        CookieUtils.setCookie(
          `${USER_PRIVACY_COOKIE_NAME}=${BOOLEAN_STRINGS.TRUE}`,
          GLOBALS.ONE_YEAR_IN_MILLISECONDS,
        );
        Tracking.track(COOKIE_BANNER_DISMISSED);
      },
    );
  };

  handleKeyPress = () => {
    this.handleClick();
  };

  render() {
    const { isPartnerSite } = this.props;

    const { wasPrivacyBannerViewed } = this.state;
    return wasPrivacyBannerViewed === BOOLEAN_STRINGS.FALSE && !isPartnerSite ? (
      <div className="cookie-banner-container">
        <div className="cookie-banner">
          <div>
            <Translate path="common.footer.cookieBanner" />
          </div>
          <button
            onClick={this.handleClick}
            onKeyPress={this.handleKeyPress}
            className="title cookie-close">
            &times;
          </button>
        </div>
      </div>
    ) : null;
  }
}

export default connect(mapStateToProps)(CookieBanner);
